import React from 'react';
import { getManifestContent } from '../../../utils/circleManifestContent';

const ManifestoSection = ({ activeCircle = 'all' }) => {
  const content = getManifestContent(activeCircle);

  if (content.type === 'default') {
    return (
      <div className="w-full flex flex-col items-center justify-center text-center px-4 lg:pl-[34px] lg:pr-[17px]" style={{ marginTop: '40px', paddingBottom: '32px' }}>
        <h1
          className="mb-[21px] pt-0.5 text-3xl lg:text-5xl"
          style={{
            fontFamily: 'Aref Ruqaa, serif',
            fontSize: 'clamp(32px, 5vw, 48px)',
            color: '#2C2B29',
            lineHeight: '1.3',
            fontWeight: '700'
          }}>
          {content.heading}
        </h1>
        <p
          className="max-w-3xl mb-0 pb-[7px] text-base lg:text-lg"
          style={{
            fontFamily: 'Amiri, serif',
            fontSize: 'clamp(16px, 2.5vw, 18px)',
            color: '#5A5A5A',
            lineHeight: '1.8',
            fontWeight: '400'
          }}>
          {content.paragraph}
          <br />
          <br />
          <span style={{ color: '#2C2B29', fontWeight: '900', fontSize: '1.6em' }}>{content.tagline}</span>
        </p>
      </div>
    );
  }

  // Circle-specific content
  const { title, description, quote, author } = content;
  return (
    <div className="w-full flex flex-col items-center justify-center text-center px-4 lg:pl-[34px] lg:pr-[17px]" style={{ marginTop: '40px', paddingBottom: '32px' }}>
      <h1
        className="mb-[21px] pt-0.5 text-3xl lg:text-5xl font-bold"
        style={{
          fontFamily: 'Aref Ruqaa, serif',
          fontSize: 'clamp(28px, 4.5vw, 44px)',
          color: '#2C2B29',
          lineHeight: '1.4'
        }}>
        {title}
      </h1>
      <div
        className="max-w-3xl mb-0 pb-[7px] text-base lg:text-lg"
        style={{
          fontFamily: 'Amiri, serif',
          fontSize: 'clamp(16px, 2.5vw, 18px)',
          color: '#5A5A5A',
          lineHeight: '1.9',
          fontWeight: '400'
        }}>
        {description && (
          <p className="m-0 mb-4">{description}</p>
        )}
        {quote && (
          <blockquote className="m-0 py-2">
            <p className="m-0" style={{ color: '#2C2B29', fontStyle: 'normal' }}>
              {quote}
            </p>
            {author && (
              <cite className="block mt-3 not-italic" style={{ color: '#5A5A5A', fontWeight: 500, fontSize: '0.95em' }}>
                — {author}
              </cite>
            )}
          </blockquote>
        )}
      </div>
    </div>
  );
};

export default ManifestoSection;
